import { render, staticRenderFns } from "./NCDDetails.vue?vue&type=template&id=40b96ab9&"
import script from "./NCDDetails.vue?vue&type=script&lang=js&"
export * from "./NCDDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports